import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLive = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.19 4.317a.75.75 0 0 1-.179 1.046 8.32 8.32 0 0 0-3.51 6.503 8.29 8.29 0 0 0 3.522 6.501.75.75 0 0 1-.861 1.228A9.79 9.79 0 0 1 2 11.842a9.82 9.82 0 0 1 4.145-7.704.75.75 0 0 1 1.046.18m2.121 2.996a.75.75 0 0 1-.231 1.035c-.65.412-1.178.95-1.547 1.567a4.14 4.14 0 0 0-.595 1.956c.029.678.23 1.345.594 1.95.37.615.896 1.15 1.546 1.56a.75.75 0 1 1-.8 1.27 6.25 6.25 0 0 1-2.032-2.057 5.6 5.6 0 0 1-.808-2.75 5.64 5.64 0 0 1 .808-2.7 6.3 6.3 0 0 1 2.03-2.063.75.75 0 0 1 1.035.232m6.41-.232a.75.75 0 0 0-.804 1.267c.65.412 1.178.95 1.548 1.567.363.607.565 1.276.594 1.956a4.1 4.1 0 0 1-.594 1.95 4.75 4.75 0 0 1-1.546 1.56.75.75 0 1 0 .8 1.27 6.25 6.25 0 0 0 2.032-2.057 5.6 5.6 0 0 0 .808-2.75 5.64 5.64 0 0 0-.808-2.7 6.3 6.3 0 0 0-2.03-2.063m1.088-2.764a.75.75 0 0 1 1.046-.18A9.82 9.82 0 0 1 22 11.89a9.79 9.79 0 0 1-4.162 7.707.75.75 0 1 1-.861-1.228 8.29 8.29 0 0 0 3.523-6.502 8.32 8.32 0 0 0-3.511-6.503.75.75 0 0 1-.18-1.046m-3.05 9.309a2.49 2.49 0 1 1-3.522-3.523 2.49 2.49 0 0 1 3.522 3.523"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLive;
